import axios from "axios";

const baseURL = "https://backendnodejs.online";
export const apiBaseURL = `${baseURL}/app.v1/api/`;
export const xNFTs = axios.create({ baseURL: apiBaseURL });

export const coverBaseURL = `${baseURL}/public/assets/coverPic/`;
export const profileBaseURL = `${baseURL}/public/assets/profilePic/`;
